const routes = [
    {
        name: 'compartilhamentoParceiro',
        path: '/parceiro/compartilhamento',
        alias: [
            '/parceiro/compartilhamento/index',
            '/contabilidade/compartilhamento',
            '/contabilidade/compartilhamento/index',
        ],
        component: () => import('../views/Compartilhar'),
    },
    {
        name: 'bannersDivulgacoesParceiro',
        path: '/parceiro/compartilhamento/banners_divulgacoes',
        alias: [
            '/parceiro/compartilhamento/banners_divulgacoes',
            '/contabilidade/compartilhamento/banners_divulgacoes',
            '/contabilidade/compartilhamento/banners_divulgacoes/index',
        ],
        component: () => import('../views/Banners'),
    },   
]

export default routes
